import { translate, sprintf } from '../../../../../utils/i18n';
import { APPROVAL_TOOL_NAMES } from '../../../constants';
import BaseToolParams from './base_tool_params';
import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.js';

const NOTE_MESSAGE = translate('IssuableToolParams.NOTE_MESSAGE', 'Post a note on %{noteParentLabel} <code>%{noteParentIid}</code> that belongs to %{workItemParentType} <code>%{workItemParentId}</code>.');
var script = {
  name: 'IssuableToolParams',
  components: {
    BaseToolParams
  },
  props: {
    toolName: {
      type: String,
      required: true,
      validator: toolName => Object.values(APPROVAL_TOOL_NAMES).includes(toolName)
    },
    toolParams: {
      type: Object,
      required: true
    }
  },
  computed: {
    project() {
      var _this$toolParams, _this$toolParams2;
      return ((_this$toolParams = this.toolParams) === null || _this$toolParams === void 0 ? void 0 : _this$toolParams.projectPath) || ((_this$toolParams2 = this.toolParams) === null || _this$toolParams2 === void 0 ? void 0 : _this$toolParams2.projectId);
    },
    title() {
      var _this$toolParams3;
      return (_this$toolParams3 = this.toolParams) === null || _this$toolParams3 === void 0 ? void 0 : _this$toolParams3.title;
    },
    labels() {
      var _this$toolParams4;
      return (_this$toolParams4 = this.toolParams) === null || _this$toolParams4 === void 0 ? void 0 : _this$toolParams4.labels;
    },
    description() {
      var _this$toolParams5, _this$toolParams6;
      return ((_this$toolParams5 = this.toolParams) === null || _this$toolParams5 === void 0 ? void 0 : _this$toolParams5.description) || ((_this$toolParams6 = this.toolParams) === null || _this$toolParams6 === void 0 ? void 0 : _this$toolParams6.body);
    },
    sourceBranch() {
      var _this$toolParams7;
      return (_this$toolParams7 = this.toolParams) === null || _this$toolParams7 === void 0 ? void 0 : _this$toolParams7.sourceBranch;
    },
    targetBranch() {
      var _this$toolParams8;
      return (_this$toolParams8 = this.toolParams) === null || _this$toolParams8 === void 0 ? void 0 : _this$toolParams8.targetBranch;
    },
    confidential() {
      var _this$toolParams9;
      return (_this$toolParams9 = this.toolParams) === null || _this$toolParams9 === void 0 ? void 0 : _this$toolParams9.confidential;
    },
    workItemParentType() {
      var _this$toolParams0, _this$toolParams1;
      if ((_this$toolParams0 = this.toolParams) !== null && _this$toolParams0 !== void 0 && _this$toolParams0.projectId) {
        return 'project';
      }
      if ((_this$toolParams1 = this.toolParams) !== null && _this$toolParams1 !== void 0 && _this$toolParams1.groupId) {
        return 'group';
      }
      return 'resource';
    },
    workItemParentId() {
      var _this$toolParams10, _this$toolParams11, _this$toolParams12;
      return ((_this$toolParams10 = this.toolParams) === null || _this$toolParams10 === void 0 ? void 0 : _this$toolParams10.url) || ((_this$toolParams11 = this.toolParams) === null || _this$toolParams11 === void 0 ? void 0 : _this$toolParams11.groupId) || ((_this$toolParams12 = this.toolParams) === null || _this$toolParams12 === void 0 ? void 0 : _this$toolParams12.projectId);
    },
    noteParentIid() {
      var _this$toolParams13, _this$toolParams14, _this$toolParams15;
      return ((_this$toolParams13 = this.toolParams) === null || _this$toolParams13 === void 0 ? void 0 : _this$toolParams13.issueIid) || ((_this$toolParams14 = this.toolParams) === null || _this$toolParams14 === void 0 ? void 0 : _this$toolParams14.mergeRequestIid) || ((_this$toolParams15 = this.toolParams) === null || _this$toolParams15 === void 0 ? void 0 : _this$toolParams15.workItemIid);
    },
    noteParentLabel() {
      switch (this.toolName) {
        case APPROVAL_TOOL_NAMES.createMergeRequestNote:
          return this.$options.i18n.MERGE_REQUEST_LABEL;
        case APPROVAL_TOOL_NAMES.createWorkItemNote:
          return this.$options.i18n.WORK_ITEM_LABEL;
        case APPROVAL_TOOL_NAMES.createIssueNote:
          return this.$options.i18n.ISSUE_LABEL;
        default:
          return '';
      }
    },
    isNote() {
      return [APPROVAL_TOOL_NAMES.createMergeRequestNote, APPROVAL_TOOL_NAMES.createWorkItemNote, APPROVAL_TOOL_NAMES.createIssueNote].includes(this.toolName);
    },
    message() {
      let message = this.$options.i18n[this.toolName] || '';
      const labelsMessage = this.$options.i18n.ASSIGN_LABELS_MESSAGE;
      const branchMessage = this.$options.i18n.BRANCH_MESSAGE;
      const confidentialMessage = this.$options.i18n.CONFIDENTIAL_MESSAGE;
      if (this.title) {
        message = `${message} ${this.$options.i18n.TITLE_MESSAGE}`;
      }
      if (this.sourceBranch && this.targetBranch) {
        message = `${message} ${branchMessage}`;
      }
      if (this.labels) {
        message = `${message} ${labelsMessage}`;
      }
      if (this.confidential) {
        message = `${message} ${confidentialMessage}`;
      }
      return sprintf(message, {
        project: this.project,
        workItemParentType: this.workItemParentType,
        workItemParentId: this.workItemParentId,
        noteParentLabel: this.noteParentLabel,
        noteParentIid: this.noteParentIid,
        ...this.toolParams
      });
    },
    accordionTitle() {
      return this.isNote ? this.$options.i18n.NOTE_ACCORDION_TITLE : '';
    }
  },
  i18n: {
    [APPROVAL_TOOL_NAMES.createIssue]: translate('IssuableToolParams.CREATE_ISSUE', 'Open an issue in project <code>%{project}</code>.'),
    [APPROVAL_TOOL_NAMES.updateIssue]: translate('IssuableToolParams.UPDATE_ISSUE', 'Update issue <code>%{issueIid}</code> in project <code>%{project}</code>.'),
    [APPROVAL_TOOL_NAMES.createEpic]: translate('IssuableToolParams.CREATE_EPIC', 'Create an epic in group <code>%{groupId}</code>.'),
    [APPROVAL_TOOL_NAMES.updateEpic]: translate('IssuableToolParams.UPDATE_EPIC', 'Update epic <code>%{epicId}</code> in group <code>%{groupId}</code>.'),
    [APPROVAL_TOOL_NAMES.createWorkItem]: translate('IssuableToolParams.CREATE_WORK_ITEM', 'Create a work item with type <em>"%{typeName}"</em> in %{workItemParentType} <code>%{workItemParentId}</code>.'),
    [APPROVAL_TOOL_NAMES.updateWorkItem]: translate('IssuableToolParams.UPDATE_WORK_ITEM', 'Update work item <code>%{workItemIid}</code> in %{workItemParentType} <code>%{workItemParentId}</code>.'),
    [APPROVAL_TOOL_NAMES.createMergeRequest]: translate('IssuableToolParams.CREATE_MERGE_REQUEST', 'Open a merge request in project <code>%{project}</code>.'),
    [APPROVAL_TOOL_NAMES.updateMergeRequest]: translate('IssuableToolParams.UPDATE_MERGE_REQUEST', 'Update merge request <code>%{mergeRequestIid}</code> in project <code>%{project}</code>.'),
    [APPROVAL_TOOL_NAMES.createMergeRequestNote]: NOTE_MESSAGE,
    [APPROVAL_TOOL_NAMES.createWorkItemNote]: NOTE_MESSAGE,
    [APPROVAL_TOOL_NAMES.createIssueNote]: NOTE_MESSAGE,
    TITLE_MESSAGE: translate('IssuableToolParams.TITLE_MESSAGE', 'Set the title "<em>%{title}</em>".'),
    BRANCH_MESSAGE: translate('IssuableToolParams.BRANCH_MESSAGE', 'From branch <code>%{sourceBranch}</code> to branch <code>%{targetBranch}</code>.'),
    ASSIGN_LABELS_MESSAGE: translate('IssuableToolParams.ASSIGN_LABELS_MESSAGE', 'Assign the labels <code>%{labels}</code>.'),
    CONFIDENTIAL_MESSAGE: translate('IssuableToolParams.CONFIDENTIAL_MESSAGE', 'Set as confidential.'),
    MERGE_REQUEST_LABEL: translate('IssuableToolParams.MERGE_REQUEST_LABEL', 'merge request'),
    ISSUE_LABEL: translate('IssuableToolParams.ISSUE_LABEL', 'issue'),
    WORK_ITEM_LABEL: translate('IssuableToolParams.WORK_ITEM_LABEL', 'work item'),
    NOTE_ACCORDION_TITLE: translate('IssuableToolParams.NOTE_ACCORDION_TITLE', "Read note's content")
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-tool-params',{attrs:{"message":_vm.message,"description":_vm.description,"custom-accordion-title":_vm.accordionTitle}})};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
